import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router';
import { permissions, defaultPermission } from '@config/authentication';
import NoPermission from '@pages/NoPermission';

export class PrivateRoute extends PureComponent {
  static propTypes = {
    component: PropTypes.func.isRequired,
    isRoleLoading: PropTypes.bool.isRequired,
    role: PropTypes.string,
    accessLevel: PropTypes.string,
  };

  static defaultProps = {
    accessLevel: defaultPermission,
  };

  static level = (role) => permissions.indexOf(role);

  get accessGranted() {
    const { role, accessLevel } = this.props;
    return PrivateRoute.level(role) >= PrivateRoute.level(accessLevel);
  }

  renderPrivateComponent = () => {
    const {
      component: Component,
      isRoleLoading,
      role,
      accessLevel,
      ...rest
    } = this.props;
    if (isRoleLoading) {
      return null;
    }
    if (role) {
      return this.accessGranted ? <Component {...rest} /> : <NoPermission />;
    }
    return (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: this.props.location },
        }}
      />
    );
  };

  render() {
    const { component, ...rest } = this.props;
    return <Route {...rest} render={this.renderPrivateComponent} />;
  }
}



// WEBPACK FOOTER //
// ./components/organisms/PrivateRoute/PrivateRoute.js